import React from 'react';
import { Box, Text, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

/**
 * MI-329: on hover, which rates a converted ("≈") value was computed with.
 *
 * Wraps the value exactly as it is drawn, so nothing visible changes until the
 * pointer is over it. `sources` is what the API says the value read
 * (`utils/rateSources`): one name, or all of them joined when it read several.
 * `label` keeps a tooltip the value already had (the "Approximate…" note) as
 * the first line; the sources follow in small type. `isDisabled` for a value
 * that was not converted.
 */
export default function RateSourceTooltip({ sources, label, isDisabled = false, children }) {
  const { t } = useTranslation('common');
  const names = (sources || []).map((code) => t(`convert.rateSource.${code}`)).join(' + ');
  return (
    <Tooltip
      hasArrow
      openDelay={300}
      isDisabled={isDisabled || (!names && !label)}
      label={(
        <Box>
          {label && <Text>{label}</Text>}
          {names && (
            <Text fontSize="2xs" opacity={0.85} mt={label ? 1 : 0}>
              {names.charAt(0).toUpperCase() + names.slice(1)}
            </Text>
          )}
        </Box>
      )}
    >
      {children}
    </Tooltip>
  );
}
